
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/custom-ai-workflow",
      function () {
        return require("private-next-pages/custom-ai-workflow.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/custom-ai-workflow"])
      });
    }
  